import { useTranslation } from "react-i18next";
import { formatDateForDisplay, formatMoneyKzt } from "@/shared/utils";
import type { AdvanceReportLine } from "../../../types";

interface Props {
  lines: AdvanceReportLine[];
}

export default function ReportLinesSection({ lines }: Props) {
  const { t } = useTranslation("AdvancesPage");

  if (lines.length === 0) return null;

  return (
    <div className="py-3 flex flex-col gap-2 border-t surface-base-stroke mt-2">
      <span className="text-body-regular-md content-base-secondary">{t("settlement.reportLinesTitle")}</span>
      {lines.map(function renderLine(line) {
        const subtitle = line.description || line.vendor;
        return (
          <div key={line.id} className="flex flex-col gap-1 p-3 radius-md surface-secondary-fill">
            <div className="flex items-center justify-between gap-2">
              <span className="text-body-bold-sm content-base-primary">{t(`settlement.reportKind.${line.kind}`)}</span>
              <span className="text-body-bold-sm content-base-primary">{formatMoneyKzt(line.gross_amount)}</span>
            </div>
            {subtitle && <p className="text-body-regular-sm content-base-secondary">{subtitle}</p>}
            {line.document_no && (
              <p className="text-body-regular-sm content-base-low">
                {line.document_no}
                {line.document_date ? ` • ${formatDateForDisplay(line.document_date)}` : ""}
              </p>
            )}
            {Number(line.vat_amount) > 0 && (
              <p className="text-body-regular-sm content-base-low">
                {t("settlement.summary.vat")}: {formatMoneyKzt(line.vat_amount)}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
